import { errorKind } from './format'

/**
 * How often a query re-asks, by how fast the thing behind it actually changes.
 *
 * In-flight operations churn constantly, counters and health drift, registries and
 * governance barely move. Nothing polls faster than it can meaningfully change.
 *
 * Born private to `hooks/useOverview.ts`, which keeps its own copies until it is
 * rewritten; every new page imports these instead of declaring a fourth set.
 */

/** In-flight work: running jobs, live chunk phases. */
export const LIVE = 10_000

/** Counters and health. */
export const FREQUENT = 30_000

/** Registries and governance. */
export const SLOW = 120_000

/**
 * `interval`, until the server has REFUSED the caller — then no poll at all.
 *
 * For the Lighthouse.Admin endpoints. A query in error keeps firing its
 * refetchInterval, so a page mounted for a caller the server has since refused
 * (a denial learned from the page's own 403, or while the gate could not say)
 * would re-send a 403 every interval for as long as it stays open. A 403 does not
 * change on a second asking; anything else (a 500, a dropped network) might, so
 * those keep polling.
 */
export function pollUnlessRefused(interval: number) {
  return (query: { state: { error: unknown } }): number | false =>
    errorKind(query.state.error) === 'forbidden' ? false : interval
}
